import React from 'react';
import './Footer.scss';

class Footer extends React.Component {

    render() {
        return (
            <footer>
                <div className="topbar light">
                    <div className="uk-container">
                        <div className="uk-grid-medium uk-flex uk-flex-bottom"  data-uk-grid>
                            <div className="uk-width-1-2@m">
                                <div className="footer-left">
                                    <p>Join us on <a href="https://discord.com/invite/rz6t3uP9hx" target="_blank" rel="noreferrer">discord</a> for more info about the blackhole experience!</p>
                                </div>
                            </div>
                            <div className="uk-width-1-2@m">
                                <div className="footer-right">
                                    <p><a href="https://immadegen.com" target="_blank" rel="noreferrer">immadegen.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
